import { BarChart3, LayoutGrid, User } from 'lucide-react';
import clsx from 'clsx';
import { NavLink, Outlet } from 'react-router-dom';

const ANALYTICS_TABS = [
  { to: '/analytics/my', label: 'My Analytics', icon: User },
  { to: '/analytics/platform', label: 'Platform Analytics', icon: BarChart3 },
  { to: '/analytics/modules', label: 'Module Analytics', icon: LayoutGrid },
];

export function AnalyticsWorkspaceLayout() {
  return (
    <div className="flex flex-col h-full bg-surface-0 overflow-hidden">
      <div className="flex items-center justify-between px-4 border-b border-surface-4 bg-surface-1 flex-shrink-0">
        <nav className="flex items-center gap-0.5 -mb-px overflow-x-auto">
          {ANALYTICS_TABS.map(({ to, label, icon: Icon }) => (
            <NavLink
              key={to}
              to={to}
              end
              className={({ isActive }) =>
                clsx(
                  'flex items-center gap-1.5 px-3 py-3 text-xs font-medium border-b-2 transition-colors whitespace-nowrap flex-shrink-0',
                  isActive
                    ? 'border-brand text-brand'
                    : 'border-transparent text-gray-400 hover:text-gray-200 hover:border-surface-4',
                )
              }
            >
              <Icon className="w-3 h-3 flex-shrink-0" />
              {label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-2 py-2 pl-3 flex-shrink-0">
          <span className="px-2 py-0.5 rounded text-[10px] font-semibold uppercase tracking-wide bg-brand/15 text-brand border border-brand/25">
            Platform
          </span>
          <span className="px-2 py-0.5 rounded text-[10px] font-semibold uppercase tracking-wide bg-surface-3 text-gray-500 border border-surface-4">
            Personal
          </span>
          <span className="px-2 py-0.5 rounded text-[10px] font-semibold uppercase tracking-wide bg-surface-3 text-gray-500 border border-surface-4">
            Modules
          </span>
        </div>
      </div>

      <div className="flex-1 min-h-0">
        <Outlet />
      </div>
    </div>
  );
}
